import script from "./DicMg.vue?vue&type=script&setup=true&lang=js"
export * from "./DicMg.vue?vue&type=script&setup=true&lang=js"

import "./DicMg.vue?vue&type=style&index=0&id=11e873ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11e873ac"]])

export default __exports__